export type StoredContactInfo = {
  email?: string;
  phoneNumber?: string;
  fullName?: string;
};

const STORAGE_KEY = 'contact_info';

let memoizedContactInfo: StoredContactInfo | undefined;

export const storeContactInfo = (info: StoredContactInfo) => {
  if (typeof localStorage === 'undefined') return;

  const currentData = localStorage.getItem(STORAGE_KEY);

  let parsed: StoredContactInfo | undefined;

  if (currentData) {
    parsed = JSON.parse(currentData);
  }

  const updated = { ...parsed, ...info };

  localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  memoizedContactInfo = updated;
};

export const loadStoredContactInfo = () => {
  if (memoizedContactInfo) return memoizedContactInfo;
  if (typeof localStorage === 'undefined') return;

  const currentData = localStorage.getItem(STORAGE_KEY);
  if (currentData) {
    const parsed = JSON.parse(currentData) as StoredContactInfo;
    memoizedContactInfo = parsed;
    return parsed;
  }
};
